// extracted by mini-css-extract-plugin
module.exports = {"addButton":"styles_addButton__22Xv0","addButtonPlus":"styles_addButtonPlus__DKSaI"};